export const ERROR_ALTURA_FOCAL = 'ERROR_ALTURA_FOCAL';
